<template>
  <div class="tw:bg-gray-100 tw:flex tw:w-full tw:py-[44px] tw:md:py-[57px]">
    <ContainerLayout>
      <div class="tw:w-full tw:md:w-1/2 lg:tw:mr-16">
        <div>
          <div class="tw:max-w-[120px] tw:pb-9">
            <TrivagoLogoPlus class="tw:inline-block tw:w-[237px] tw:h-[23px]" />
          </div>

          <!-- Mobile Video -->
          <div class="tw:flex tw:md:hidden tw:mb-9">
            <StudioPlusHeroVideo class="tw:m-auto tw:mx-auto tw:w-full tw:h-[312px]" />
          </div>

          <h3 class="tw:font-bold tw:text-2xl tw:md:text-header-big tw:mb-2" v-html="$t('plus_product_page_header')" />
          <div class="tw:text-xl tw:text-gray-700 tw:mb-8 tw:leading-[30px]" v-if="isAdmin">
            {{ $t('plus_product_page_subtext') }}
          </div>

          <div class="tw:mb-4 tw:flex tw:items-start tw:flex-col">
            <div class="tw:bg-red-200 tw:text-red-800 tw:py-1 tw:px-2 tw:rounded tw:text-sm">
              <i18n-t keypath="plus_product_page_price">
                <template #SubscriptionPrice>
                  <strong v-if="!isLoading">{{ formatCurrency(price) }}</strong>

                  <SmallDotLoader v-else color="#B4183A" />
                </template>
              </i18n-t>
            </div>
            <small class="tw:text-gray-700 tw:text-xs tw:mt-1">{{
              `*${$t('business_studio_plus_tax_disclaimer')}`
            }}</small>
          </div>

          <div class="tw:text-xl tw:text-gray-700 tw:mb-8 tw:leading-[30px]" v-if="!isAdmin">
            {{ $t('plus_admin_log_in_text') }}
          </div>

          <div class="tw:flex tw:flex-col tw:md:flex-row tw:md:items-start tw:mt-4">
            <MainButton @click="upgradeSub" dataTestId="plus-hero-upgrade-btn">{{
              isAdmin ? $t('plus_product_page_cta') : $t('rc_admin_log_in_cta')
            }}</MainButton>
          </div>
        </div>
      </div>
      <!-- Web Video -->
      <div class="tw:hidden tw:md:flex tw:md:w-1/2 tw:w-full tw:relative tw:mx-auto">
        <StudioPlusHeroVideo class="tw:m-auto tw:mx-auto tw:h-[413px] tw:mr-16" />
      </div>
    </ContainerLayout>
  </div>
</template>
<script setup>
import { useStore } from 'vuex'
import { selectedAccommodationId } from '@/layouts/queries'

import MainButton from '@/components/base/buttons/MainButton.vue'
import TrivagoLogoPlus from '@/components/icons/TrivagoLogoPlus.svg?component'
import SmallDotLoader from '@/components/base/loaders/SmallDotLoader.vue'
import ContainerLayout from '@/layouts/ContainerLayout.vue'
import StudioPlusHeroVideo from '@/components/studioPlus/StudioPlusHeroVideo.vue'

import appAnalytics from '@/utils/tracking'

import { useFormatting } from '@/composables/useFormatting'

const emit = defineEmits(['upgradeSub'])

const store = useStore()
const props = defineProps({
  price: Number,
  currency: String,
  isLoading: Boolean,
  isAdmin: Boolean,
})

const { formatCurrency } = useFormatting()

const upgradeSub = () => {
  if (props.isAdmin) {
    appAnalytics.track(appAnalytics.events.SP_CLICK_UPGRADE_BANNER, {
      accommodationId: selectedAccommodationId.value,
    })
    emit('upgradeSub')
  } else {
    appAnalytics.track(appAnalytics.events.SP_LOGIN_AS_ADMIN_CLICKED, {
      accommodationId: selectedAccommodationId.value,
    })
    store.dispatch('session/logout', '/studio-plus/compare?loginAsAdmin=true')
  }
}
</script>
<style scoped>
.current-price :deep(span) {
  font-size: 32px;
  font-weight: bold;
}
.shadow {
  box-shadow:
    0 2px 4px 0 rgba(63, 87, 189, 0.1),
    0 2px 10px 0 rgba(108, 112, 122, 0.15);
}
</style>
